import color from "@definitions/mui/color";
import { fontFamSecondary } from "@definitions/mui/custom";
import { makeStyles } from "@mui/styles";

interface IProps {
  isBtnOutline?: boolean;
}

const useStyles = ({ isBtnOutline }: IProps) => {
  return makeStyles(() => ({
    "@keyframes smoothScroll": {
      "0%": {
        transform: "translateY(-142px)",
      },
      "100%": {
        transform: "translateY(0)",
      },
    },
    "@keyframes smoothScrollBottom": {
      "0%": {
        transform: "translateY(100%)",
      },
      "100%": {
        transform: "translateY(0)",
      },
    },
    stickyHeader: {
      backgroundColor: color.white,
      position: "fixed",
      top: 0,
      width: "100%",
      boxShadow: "0px 6px 12px rgba(46, 67, 77, 0.1)",
      transition: "all 0.5s ease",
      animation: `$smoothScroll 1s forwards`,
      zIndex: 1,

      "& .MuiInputBase-root": {
        width: "100%",
      },
    },
    clickLink: {
      "& span": {
        color: color.primary.main,
      },
    },
    buttonStyle: {
      padding: 12,
      fontSize: 16,
      fontWeight: 700,
      width: "100%",
      backgroundColor: "transparent",
      color: color.primary.main,
      border: `1px solid ${color.primary.main}`,
      boxShadow: "none",
      lineHeight: "24px",
      fontFamily: fontFamSecondary,

      ...(isBtnOutline && {
        "&:hover": {
          backgroundColor: color.primary.main,
          color: color.white,
        },
      }),
    },
    dialogLogout: {
      "& .MuiDialog-container": {
        alignItems: "flex-end",
      },
      "& .MuiPaper-root": {
        margin: 0,
        width: "100%",
        borderTopLeftRadius: 24,
        borderTopRightRadius: 24,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
      },
      "& .MuiDialog-paperScrollBody": {
        margin: 0,
        width: "100%",
        maxWidth: "100%",
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
        verticalAlign: "bottom",
      },
      "& .MuiDialogTitle-root": {
        padding: 0,
        margin: 0,
        "& svg": {
          top: 27,
          right: 24,
        },
      },
      "& .MuiDialogContent-root": {
        margin: 0,
        padding: 24,
        "& .MuiDialogTitle-root": {
          padding: 0,
        },
        "& .MuiDialogContent-root": {
          padding: 0,
        },
      },
      "& .MuiDialogActions-root": {
        marginTop: 24,
        padding: 0,
      },
      "&. MuiDialogActions-root": {
        "&:not(:first-of-type)": {
          marginLeft: 16,
        },
      },
      closeIcon: {
        top: 16,
        left: 16,
      },
    },
    listPopup: {
      "& li": {
        "& + li": {
          paddingTop: 16,
          marginTop: 16,
          borderTop: `1px solid ${color.grey.light}`,
        },
      },
    },
    dialogTerms: {
      "& h2": {
        "& svg": {
          display: "none",
        },
      },
    },
    dialogTitle: {
      padding: 0,
      position: "relative",
      zIndex: 2,
      transition: "all 0.5s ease",
      "&.scroll": {
        animation: `$smoothScroll 500ms forwards`,
      },
      "&.scrollBottom": {
        animation: `$smoothScrollBottom 500ms forwards`,
      },
    },
  }))();
};

export default useStyles;
